import { render } from "./CouponManager.vue?vue&type=template&id=5a1bb00c&scoped=true"
import script from "./CouponManager.vue?vue&type=script&lang=js"
export * from "./CouponManager.vue?vue&type=script&lang=js"

import "./CouponManager.vue?vue&type=style&index=0&id=5a1bb00c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1bb00c"]])

export default __exports__